import $ from 'jquery';
import _ from 'lodash';
import text from './text';
import csrf from './csrf'
import 'bootstrap';
import 'selectize';

import 'font-awesome.css'

var defaults = {
  ctx: '',
  lang: 'en',
  create: false,
  onAjaxError: function () {},
  searchFields: ['name'],
  optionField: ['name'],
  itemField: ['name'],
  valueField: ['id'],
  elem: undefined,
  parameters: undefined,
  exclude: undefined,
  numOptions: 10,
}

export default {
  init: function (opts) {
    var render = function (what) {
      var _what = what
      switch (what) {
        case 'item':
        case 'option':
          break
        default:
          console.error('what can take the values "item" or "option"')
          return
      }
      return function (item, escape) {
        var a = $('<div/>')
        $('<div/>')
          .addClass('select-item')
          .html(_(D[_what + 'Field']).map(function (e) {
            return escape(item[e])
          }).join(' - ')).appendTo(a)
        return a.html()
      }
    }

    var onLoad = function (query, callback) {
      if (!query.length) return callback()
      var url
      if (!_(D.parameters).isEmpty()) {
        var vals = []
        var stop = false;
        _(D.parameters).each(function (e) {
          var $elem = $('[name="' + e + '"]')
          if ($elem.length == 0) {
            console.error('field ' + D.parameters + ' not found, no ajax request will be sent')
            stop = true
            return false
          }
          var val = $elem.val()
          if (val !== undefined && !_(val).isEmpty()) {
            vals.push(val)
          } else {
            console.log('field ' + D.parameters + ' is not set. No ajax request will be sent.')
            stop = true
            return false
          }
        })
        if (stop) {
          D.sl.clear()
          D.sl.clearOptions()
          callback()
          return
        }
        url = D.elem.data('url') + '/' + _(vals).join('/') + '?json'
      } else {
        url = D.elem.data('url') + '?json'
      }
      console.log('asking for ajax autocompletion from url: ' + url)
      var _exclude

      if (!_(D.exclude).isEmpty()) {
        _exclude = _(D.exclude)
      }
      $.ajax({
        url: url,
        type: 'POST',
        headers: csrf(),
        data: { prefix: query },
        error: function (qXHR, textStatus, errorThrown) {
          D.onAjaxError(qXHR, textStatus, errorThrown)
          callback()
        },
        success: function (res, textStatus, jqXHR) {
          console.log('ajax response received for autocomplete' + D.elem)
          if (res.errors.length !== 0) {
            // TODO: visually show that something is wrong with auto-completion
            console.log('errors occurred')
            callback()
          } else if (res.data && res.data.length > 0) {
            console.log('entries received: ' + res.data.length)
            if (_exclude !== undefined) {
              var _excludeValues = _exclude.map(function (e) {
                var val = $('[name="' + e + '"]').val()
                if (val === undefined) {
                  console.log('field ' + D.parameters + ' is not set, not removing any options')
                  return undefined
                }
                return val
              }).compact()

              if (!_.isEmpty(_excludeValues)) {
                _(res.data).remove(function (e) {
                  if (_excludeValues.includes(e.id)) {
                    console.log('Explicitly removing option ' + e)
                    return true
                  }
                  return false
                })
              }
            }
            callback(res.data.slice(0, D.numOptions))
          } else {
            console.log('0 results received')
            callback()
          }
        },
      })
    }

    if (opts.elem === undefined || _(opts).isEmpty()) {
      console.error('AutoSelectize:elem cannot be empty/undefined', D)
      return
    }
    if (typeof opts.elem === 'string') {
      opts.elem = $(opts.elem)
    }
    if (opts.elem.length === 0) {
      console.error('AutoSelectize:elem does not exist', D)
      return
    }

    var htmlData = opts.elem.data()

    // data-infofields initializes optionField and itemField...
    var htmlOpts1 = {
      searchFields: htmlData.infofields,
      optionField: htmlData.infofields,
      itemField: htmlData.infofields,
    }

    // but if data-optionfields and data-itemfields they will override
    // data-infofields...
    var htmlOpts2 = {
      searchFields: htmlData.searchfields,
      optionField: htmlData.optionfields,
      itemField: htmlData.itemfields,
    }

    // which are finally overriden by opts
    var D = $.extend({}, defaults, htmlOpts1, htmlOpts2, opts || {})
    console.log('AutoSelectize:init', D)
    var parameters = D.elem.data('parameters')
    D.parameters = parameters === undefined && !_(parameters).isEmpty() ? [] : parameters
    var exclude = D.elem.data('exclude')
    D.exclude = exclude === undefined && !_(exclude).isEmpty() ? [] : exclude

    D.elem.selectize({
      copyClassesToDropdown: false,
      plugins: ['remove_button', 'restore_on_backspace'],
      allowEmptyOption: D.elem.hasClass('empty_option'),
      create: D.create,
      valueField: D.valueField,
      searchField: D.searchFields,
      selectOnTab: true,
      load: onLoad,
      placeholder: D.elem.data('msg'),
      render: {
        option_create: function (data, escape) {
          return '<div class="create">' + text('misc.add') +
            ' <strong>' + escape(data.input) + '</strong>&hellip;</div>';
        },
        option: render('option'),
        item: render('item'),
      },
      onInitialize: function () {
        console.log('onInitialize')
        D.elem.find('+.selectize-control.autoselect')
          .append('<span class="fa fa-spinner fa-2x selectize-icon">' +
            '</span><span class="fa fa-spinner fa-2x fa-pulse selectize-loading-icon"></span>')
        D.elem.find('+.selectize-control').removeClass('form-control')
        D.elem.find('+.selectize-control input').attr('role', 'presentation')
      },
    })

    D.sl = D.elem[0].selectize
    var options = D.elem.data('options')
    if (options === undefined) {
      options = []
    }

    if (!_(options).isArray()) {
      options = [options]
    }
    _(options).each(function (option) {
      _(D.itemField).each(function (i) {
        if (option[i] === undefined) {
          option[i] = ''
        }
      })
      D.sl.addOption(option)
      D.sl.addItem(option[D.valueField])
    })
    if (options.length !== 0) {
      D.sl.refreshItems()
    }
    D.elem.trigger('selectizeInit')
    return { }
  },
}
